import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import _ from 'lodash';

const caculatePanelIndexInScreenView = (currentStartIndex, panelList) => {
    let newPanelListClone = _.cloneDeep(panelList)
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    let currentPanel = newPanelListClone[currentStartIndex];
    let currentPanelSize = currentPanel?.size;

    let nextPanelSize = newPanelListClone[currentStartIndex + 1]?.size;
    let next2PanelSize = newPanelListClone[currentStartIndex + 2]?.size;
    let prevPanelSize = newPanelListClone[currentStartIndex - 1]?.size;
    let prev2PanelSize = newPanelListClone[currentStartIndex - 2]?.size;
    console.log('caculatePanelIndexInScreenView', {currentPanelSize, nextPanelSize, next2PanelSize, prevPanelSize, prev2PanelSize})
    let isLastScreen = currentViewIsLastScreen(currentPanelSize, nextPanelSize, next2PanelSize);

    console.log('caculatePanelIndexInScreenView isLastScreen', isLastScreen)
    if (!isLastScreen) {
        return currentStartIndex;
    }

    
    if (currentPanelSize === Constant.PANEL_SIZE.SIZE_3) {
        return currentStartIndex;
    }

    if (currentPanelSize === Constant.PANEL_SIZE.SIZE_2 && !nextPanelSize) {
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_1) {
            return currentStartIndex -1;
        }
    }


    if (currentPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_2 && !nextPanelSize) {
            return currentStartIndex -1;
        }

        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_1) {
            if (prev2PanelSize === Constant.PANEL_SIZE.SIZE_1 && !nextPanelSize) {
                return currentStartIndex - 2;
            }
            return currentStartIndex - 1;
        }
    }

    return currentStartIndex;
};

const currentViewIsLastScreen = (currentPanelSize, nextPanelSize, next2PanelSize ) => {
    if (!nextPanelSize) {
        return true;
    } 
    // if current size = 2 or 3, so dont change current index.
    if (nextPanelSize === Constant.PANEL_SIZE.SIZE_1 && !next2PanelSize && currentPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        return true;
    }

   return false;
}



const caculateIndexPanelRelateExist = (currentStartIndex, openRelatePanelType, panelList, openPanelIndex, openIndexPanel, isBringPanelCloseTogether) => {
    let openPanel = panelList[openPanelIndex];
    let openPanelSize = openPanel?.size;

    let newPanelListClone = _.cloneDeep(panelList)
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    let openRelatePanelIndex = newPanelListClone.findIndex((panel) => panel.type === openRelatePanelType);
    

    let openRelatePanel = newPanelListClone[openRelatePanelIndex];

    let openRelatePanelSize = openRelatePanel?.size
    let nextPanelSize = newPanelListClone[openRelatePanelIndex + 1]?.size;
    let next2PanelSize = newPanelListClone[openRelatePanelIndex + 2]?.size;

    let prePanelSize = newPanelListClone[openRelatePanelIndex - 1]?.size;

    let distanceTwoPanel = Math.abs(openRelatePanelIndex - openPanelIndex);

    console.log('caculatePanelInterlockIndex ', {openRelatePanelIndex, currentStartIndex, openPanelIndex})



    if (isBringPanelCloseTogether) {
       
        let bringopenIndexPanelIndex = newPanelListClone.findIndex((panel) => panel.type === openIndexPanel?.type)
        console.log('isBringPanelCloseTogether', {openRelatePanelIndex, bringopenIndexPanelIndex} )
        return openRelatePanelIndex;
        // let bringopenIndexPanelIndex = newPanelListClone.findIndex((panel) => panel.type === openIndexPanel?.type)
    }
    let openRelatePanelAtLeft = true;
    if (openRelatePanelIndex >= openPanelIndex) {
        openRelatePanelAtLeft = false;
    }

    console.log('caculatePanelInterlockIndex ', {openRelatePanelAtLeft, prePanelSize, nextPanelSize})
    
    if (openRelatePanelAtLeft === false) {
        if (distanceTwoPanel === 1) {
            if (openPanelIndex === currentStartIndex) {
                if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_2 && openPanelSize === Constant.PANEL_SIZE.SIZE_1) {
                    return openPanelIndex;
                }
                if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 && 
                    [Constant.PANEL_SIZE.SIZE_2, Constant.PANEL_SIZE.SIZE_1].includes(openPanelSize)) {
                    return openPanelIndex;
                }
            }
            
        }
        

        if (distanceTwoPanel === 2 && 
            openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 &&
            prePanelSize === Constant.PANEL_SIZE.SIZE_1 && 
            openPanelSize === Constant.PANEL_SIZE.SIZE_1
        ) {
            return openPanelIndex
        } 
        return currentStartIndex;
    }


    if (openRelatePanelIndex === currentStartIndex) {
        return currentStartIndex;
    }

    if (distanceTwoPanel === 2 && openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 && nextPanelSize === Constant.PANEL_SIZE.SIZE_1 && openPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        return openRelatePanelIndex;
    }   
    
    console.log('caculatePanelInterlockIndex', {openRelatePanelIndex, openRelatePanelSize, nextPanelSize, prePanelSize})

    if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_2 && nextPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        return openRelatePanelIndex;
    }

    if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 && nextPanelSize === Constant.PANEL_SIZE.SIZE_2) {
        return openRelatePanelIndex;
    }

    if (
        openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 &&
        nextPanelSize === Constant.PANEL_SIZE.SIZE_1
    ) {
        switch (prePanelSize) {
            case Constant.PANEL_SIZE.SIZE_1:
                return openRelatePanelIndex - 1;
            case Constant.PANEL_SIZE.SIZE_2:
                return openRelatePanelIndex;
            default:
                return currentStartIndex;
        }
    }

    return currentStartIndex;
};


const caculateIndexPanelRelate = (currentStartIndex, openRelatePanelType, panelList) => {
    let newPanelListClone = _.cloneDeep(panelList)
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    let openRelatePanelIndex = newPanelListClone.findIndex((panel) => panel.type === openRelatePanelType);
    let openRelatePanel = newPanelListClone[openRelatePanelIndex];
    let openRelatePanelSize = openRelatePanel?.size
    let nextPanelSize = newPanelListClone[openRelatePanelIndex + 1]?.size;
    let next2PanelSize = newPanelListClone[openRelatePanelIndex + 2]?.size;
    let prePanelSize = newPanelListClone[openRelatePanelIndex - 1]?.size;


    if (openRelatePanelIndex === currentStartIndex) {
        return currentStartIndex;
    }

    if (!prePanelSize) {
        const startIndex = 0;
        return startIndex
    }

    if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_2 && nextPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        return openRelatePanelIndex;
    }

    if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 && nextPanelSize === Constant.PANEL_SIZE.SIZE_2) {
        return openRelatePanelIndex;
    }

    if (openRelatePanelSize === Constant.PANEL_SIZE.SIZE_1 && nextPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        if (prePanelSize === Constant.PANEL_SIZE.SIZE_2) {
            return openRelatePanelIndex;
        }
        if (prePanelSize === Constant.PANEL_SIZE.SIZE_1) {
            return openRelatePanelIndex - 1;

        }
    }

    return currentStartIndex;
};


const checkBringPanelCloseTogether = (newPanelList, openRelatePanelType, openPanelIndex) => {
    const openRelatePanelTypeIndex = newPanelList.findIndex(panel => panel.type === openRelatePanelType);
    const openRelatePanelTypeSize = newPanelList[openRelatePanelTypeIndex]?.size;

    const openIndexPanel = newPanelList[openPanelIndex];
    const openIndexPanelSize = openIndexPanel?.size


    if (Math.abs(openRelatePanelTypeIndex - openPanelIndex) !== 1) {
        // view 1-1-1 vs 2 panel in view => not bring
        if (Math.abs(openRelatePanelTypeIndex - openPanelIndex) === 2 ) {
            let centerPanel = newPanelList[openRelatePanelTypeIndex + 1];
            if (openRelatePanelTypeIndex > openPanelIndex) {
                centerPanel = newPanelList[openRelatePanelTypeIndex - 1];
            }   
            let centerPanelSize = centerPanel?.size;
            console.log('checkBringPanelCloseTogether', {openRelatePanelTypeSize, openIndexPanelSize, centerPanelSize})
            if (openRelatePanelTypeSize === Constant.PANEL_SIZE.SIZE_1 &&
                openIndexPanelSize === Constant.PANEL_SIZE.SIZE_1 &&
                centerPanelSize === Constant.PANEL_SIZE.SIZE_1
            ) {
                return false;
            }
        }

        return true;
       
    }
    return false;
};

const calculateIndexOpenExistPanel = (openPanelData, startPanelIndex, newPanelList, isOpenPanelAi, isAddNewTab) => {
    if (!openPanelData) return 0;
    console.log("openPanelData", openPanelData)
    console.log("newPanelList", newPanelList)
    let newPanelListClone = _.cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);
    
    const openPanelIndex = newPanelListClone.findIndex((panel) => panel.id === openPanelData.id);
    const openPanelSize = openPanelData?.size || Constant.PANEL_SIZE.SIZE_1;

    const prevPanelData = newPanelListClone[openPanelIndex -1];
    const prevPanelSize = prevPanelData?.size;

    if (isOpenPanelAi) {
        const openAiPanel = newPanelListClone.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
        const knowledgeListPanel = newPanelListClone.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
        if (knowledgeListPanel?.size === Constant.PANEL_SIZE.SIZE_3) {

        }
    }

    if (openPanelSize === Constant.PANEL_SIZE.SIZE_3 || !prevPanelData) {
        return openPanelIndex;
    }

    if (openPanelSize === Constant.PANEL_SIZE.SIZE_2) {
        // view 1-2
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_1) {
            return openPanelIndex - 1;
        }
        // view 2-2 || view 3-2 
        return openPanelIndex;
    }

    if (openPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        // view for 1-1
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_1) {
            // pending
            // if (isAddNewTab) {
            //     return openPanelIndex - 1
            // }
            // special view for 1-1-1
            const prev2PanelData = newPanelListClone[openPanelIndex - 2];
            if (prev2PanelData && prev2PanelData?.size === Constant.PANEL_SIZE.SIZE_1) {
                return openPanelIndex - 2;
            }
            return openPanelIndex - 1
        }

        // view 2-1
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_2) {
            return openPanelIndex - 1;
        }
        // view 3-1
        if (prevPanelSize === Constant.PANEL_SIZE.SIZE_3) {
            return openPanelIndex;
        }
        return openPanelIndex;
    }
}

const PanelUtils = {
    caculatePanelIndexInScreenView,
    caculateIndexPanelRelateExist,
    checkBringPanelCloseTogether,
    caculateIndexPanelRelate,
    calculateIndexOpenExistPanel
}

export default PanelUtils;